import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import Footer from "../../components/Footer";

const NepalMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS in Nepal</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Degree Awarded:</h3>
            <p className="detail-text">MBBS</p>
          </div>

          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">
              5.5 years (4.5 years academic + 1-year compulsory internship,
              which can be done in Nepal or India if permitted)
            </p>
          </div>

          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>
                10+2 or equivalent with Physics, Chemistry, Biology, and English
              </li>
              <li>Minimum 50% marks in PCB</li>
              <li>Must qualify NEET (for Indian students)</li>
              <li>
                University-specific entrance exams may also be required (e.g.,
                KU or TU entrance tests)
              </li>
            </ul>
          </div>

          <div className="detail-item">
            <h3 className="detail-title">Medium of Instruction:</h3>
            <p className="detail-text">English</p>
          </div>

          <div className="detail-item">
            <h3 className="detail-title">Recognition:</h3>
            <ul className="detail-list">
              <li>NMC (India)</li>
              <li>WHO</li>
              <li>WFME</li>
            </ul>
          </div>

          <div className="detail-item">
            <h3 className="detail-title">Advantages:</h3>
            <ul className="detail-list">
              <li>Indian faculty and similar curriculum</li>
              <li>Cultural and language similarities</li>
              <li>No donation in most colleges</li>
              <li>Indian food and facilities easily available</li>
            </ul>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top MBBS Universities/Colleges in Nepal
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                Institute of Medicine (IOM), Tribhuvan University – Kathmandu
              </h3>
              <p className="university-description">
                Premier government medical college in Nepal. Highly reputed and
                affordable.
              </p>
            </div>

            <div className="university-card">
              <h3 className="university-name">
                B.P. Koirala Institute of Health Sciences (BPKIHS), Dharan
              </h3>
              <p className="university-description">
                Autonomous health sciences university. Recognized in India;
                conducts its own entrance test.
              </p>
            </div>

            <div className="university-card">
              <h3 className="university-name">
                Kathmandu University School of Medical Sciences (KUSMS),
                Dhulikhel
              </h3>
              <p className="university-description">
                Major university with multiple affiliated colleges. Modern
                facilities and Indian-friendly environment.
              </p>
            </div>

            <div className="university-card">
              <h3 className="university-name">
                Manipal College of Medical Sciences (MCOMS), Pokhara
              </h3>
              <p className="university-description">
                Affiliated to Kathmandu University. Operated by the Manipal
                Group (India).
              </p>
            </div>

            <div className="university-card">
              <h3 className="university-name">
                Nepalgunj Medical College (NGMC), Nepalgunj
              </h3>
              <p className="university-description">
                Kathmandu University affiliated. Popular among Indian students.
              </p>
            </div>

            <div className="university-card">
              <h3 className="university-name">
                Nobel Medical College, Biratnagar
              </h3>
              <p className="university-description">
                Kathmandu University affiliated. Offers quality clinical
                training and Indian curriculum.
              </p>
            </div>

            <div className="university-card">
              <h3 className="university-name">
                National Medical College, Birgunj
              </h3>
              <p className="university-description">
                Affiliated to Tribhuvan University. Good infrastructure and
                large Indian student base.
              </p>
            </div>

            <div className="university-card">
              <h3 className="university-name">
                KIST Medical College, Lalitpur
              </h3>
              <p className="university-description">
                Reputed college offering quality MBBS education with focus on
                clinical exposure.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default NepalMbbs;
